import sileo from 'sileo';

const Memo = new sileo.Model('hqzen', 'memorandum');
const WorkforceMemo = new sileo.Model('hqzen', 'workforce-memorandum');
const MemoList = new sileo.Model('hqzen', 'memorandum-list');
const WorkforceMemoList = new sileo.Model('hqzen', 'workforce-memorandum-list');
const MemoAmazon = new sileo.Model('hqzen', 'memorandum-amazon-data');
const MemorandumDetails = new sileo.Model('hqzen', 'memorandum-details');
const WorkforceMemorandumDetails = new sileo.Model('hqzen', 'workforce-memorandum-details');
const MemorandumRecipients = new sileo.Model('hqzen', 'memorandum-recipients');
const EmployeeMemorandums = new sileo.Model('hqzen', 'employee-memorandums');

const actions = {
    createMemorandum(context, data) {
        return Memo.objects.create(data);
    },

    createWorkforceMemorandum(_, data) {
        return WorkforceMemo.objects.create(data);
    },

    getMemorandumDetails(context, pk) {
        return MemorandumDetails.objects.get(pk);
    },

    getWorkforceMemorandumDetails(_, pk) {
        return WorkforceMemorandumDetails.objects.get(pk);
    },

    getMemorandumRecipients(context, filters) {
        return MemorandumRecipients.objects.filter(filters);
    },

    fetchMemorandumAmazon() {
        return MemoAmazon.objects.filter().then(data => {
            return data.amazon;
        }).catch(err => {
            console.error(err);
            return null;
        });
    },

    fetchMemorandums(context, filters) {
        return MemoList.objects.filter(filters);
    },

    getEmployeeMemorandums(context, filters) {
        return EmployeeMemorandums.objects.filter(filters);
    },

    fetchWorkforceMemorandums(_, filters) {
        return WorkforceMemoList.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    actions
};
